export const formatObjectForDropdown = (obj: Record<string, string>) => {
  return Object.entries(obj).map(([key, value]) => {
    return {
      label: value,
      value: key,
    }
  })
}